import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import Barbers from '../../../barbers/Barbers';

const BarbersContainer = compose(
  withRouter,
  withHandlers({
    onBarberClick: props => (e, _barber, _shop, barberLink) => {
      e.preventDefault();
      props.router.replace(barberLink);
    },
  })
)(Barbers);

export default BarbersContainer;



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/services/containers/Barbers.js